export const styles = theme => ({
  container: {
    textDecoration: 'none',
    '&:hover, & a, & a:hover': {
      cursor: 'pointer',
      textDecoration: 'none !important'
    }
  }
});
